export default function () {
  function wrap(top, bottom){
    var matches = document.querySelectorAll('.article .youtube-player');
    for (var i = 0; i < matches.length; i++){
      var modified = top + matches[i].outerHTML + bottom;
      matches[i].outerHTML = modified;
    }
  }
  wrap('<div class="aspect-ratio">', '</div>');
}